// Депозитите в дневните отчети — САМО показване на полетата от BE
// (`reports/service_deposits.py`). Взетите депозити са по метод; взетите в брой
// вече са вътре в „За отчитане" (`amount_to_report`). Платеното С депозит е
// редът „Плащане с депозит" (`system_code = "deposit"`) в `payment_breakdown`.
//
// Сумите се събират в ЦЕЛИ центове; модулът е в `lib/`, защото го ползват и
// хартиите в „Маркиране", и списъците в „Справки".

import type {
  DepositTakenBreakdownRow,
  PaymentBreakdownItem,
  ReportDepositFields,
  UserBreakdown,
} from "../api/reports";
import { DEPOSIT_SYSTEM_CODE } from "../api/paymentMethods";
import { parseMoneyToCents } from "../utils/money";

const centsOf = (value: string | number | null | undefined): number =>
  parseMoneyToCents(value) ?? 0;

/** Взетите депозити на отчет — в евро. */
export type ReportDeposits = {
  total: number;
  cash: number;
  rows: DepositTakenBreakdownRow[];
};

export const reportDepositsOf = (report: ReportDepositFields): ReportDeposits => ({
  total: centsOf(report.deposits_taken_amount) / 100,
  cash: centsOf(report.deposits_taken_cash_amount) / 100,
  rows: report.deposits_taken_breakdown ?? [],
});

/** Има ли отчетът взети депозити — гейтът на секцията „Депозити". */
export const hasReportDeposits = (report: ReportDepositFields): boolean =>
  centsOf(report.deposits_taken_amount) !== 0;

/** Редът „Плащане с депозит" в разбивката по методи. */
export const isDepositPaymentRow = (row: Pick<PaymentBreakdownItem, "system_code">): boolean =>
  row.system_code === DEPOSIT_SYSTEM_CODE;

/** Платеното с депозит зад отчета — сумата на реда „Плащане с депозит". */
export const depositPaymentAmountOf = (
  breakdown: readonly PaymentBreakdownItem[] | null | undefined,
): number =>
  (breakdown ?? [])
    .filter(isDepositPaymentRow)
    .reduce((sum, row) => sum + centsOf(row.amount), 0) / 100;

/** Сервитьор с взет депозит в „Разбивка по потребители". */
export const hasUserDeposit = (user: Pick<UserBreakdown, "deposits_taken_amount">): boolean =>
  centsOf(user.deposits_taken_amount) !== 0;
